export const validateForm=(number,value)=>{
    //validates numbers 0-9, no negatives and all
    if(number === 0){
        const regEx=/^\d+$/
        return regEx.test(value);
    }
}